import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, isDevMode } from '@angular/core';
import { environment } from 'src/environments/environment';

import { API_PATH } from '../utils/constants/api.constants';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    @Inject('WINDOW') public window: Window,
    @Inject(DOCUMENT) public document: Document,
    public authenticationService: AuthenticationService,
    private http: HttpClient,
  ) { }

  getAuthentication(data:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.LOGIN;
    return this.http.post(url, data);
  }

  googleSignIn() {
    this.window.location.href = this.authenticationService.getAPIBaseURL() + '/' + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GOOGLE_LOGIN;}
  registerUser(data:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.REGISTER;
    return this.http.post(url, data);
  }

  getLocation(params:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GET_SIGN_UP;
    return this.http.get<any>(url, {params});
  }

  generateOTP(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GENERATE_OTP;
    return this.http.post(url, data);
  }

  getOTP(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GET_OTP;
    return this.http.post(url, data);
  }

  verifyOTP(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.VERIFY_OTP;
    return this.http.post(url, data);
  }

  generateForgetOTP(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GENERATE_OTP_FORGET_PASS;
    return this.http.post(url, data); 
  }

  verifyForgetOTP(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.VERIFY_OTP_FORGET_PASS;
    return this.http.post(url, data); 
  }

  createNewPass(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.CREATE_NEW_PASS;
    return this.http.post(url, data); 
  }

  changePass(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.CHANGE_PASSWORD;
    return this.http.post(url, data); 
  }

  initialchangePass(data:any){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.INITIAL_CHANGE_PASSWORD;
    return this.http.post(url, data); 
  }

  getUserDetail(){
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.USER_DETAIL;
    return this.http.get<any>(url);
  }

  getCategories(params:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH+ API_PATH.AUTH  + API_PATH.GET_CATEGORIES ;
    return this.http.get<any>(url, {params}); 
  }
  getAuthenticationSalt(data:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GENERATE_SALT;
    return this.http.post(url, data);
  }
  getOtpSalt(data:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GET_OTP_SALT;
    return this.http.post(url, data);
  }
  getCommonOtpSalt(data:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.AUTH + API_PATH.GET_COMMON_OTP_SALT;
    return this.http.post(url, data);
  }
  clearSession(data:any) {
    const url = environment.BASE_URL + API_PATH.API_BASE_PATH + API_PATH.CLEAR_SESSION;
    return this.http.get<any>(url, data);
  }
}
